export default [
	"gray-100",
	"gray-200",
	"gray-300",
	"gray-400",
	"gray-500",
	"gray-600",
	"gray-700",
	"gray-800",
	"gray-900",
	"primary-100",
	"primary-200",
	"primary-300",
	"primary-400",
	"primary-500",
	"secondary-100",
	"secondary-200",
	"secondary-300",
	"secondary-400",
	"secondary-500",
	"warning-100",
	"warning-200",
	"warning-300",
	"warning-400",
	"warning-500",
	"success-100",
	"success-200",
	"success-300",
	"success-400",
	"success-500",
	"danger-100",
	"danger-200",
	"danger-300",
	"danger-400",
	"danger-500",
	"color1-100",
	"color1-200",
	"color1-300",
	"color2-100",
	"color2-200",
	"color2-300",
	"color3-100",
	"color3-200",
	"color3-300",
	"color4-100",
	"color4-200",
	"color4-300",
	"color5-100",
	"color5-200",
	"color5-300",
	"color6-100",
	"color6-200",
	"color6-300"
] as const;
